export default __webpack_public_path__ + "static/media/image_3.6105ba9f.png";